console.log("Showcase.Redesign.js loaded");

class ShowcaseRedesign {

	constructor(element) {
		this.element = element;
		this.headlineWrapper = this.element.querySelector(".showcase-headline-wrapper");
		this.logoDesktop = this.element.querySelector(".logo-desktop");
		
		if (this.headlineWrapper && this.logoDesktop) {
			this.init();
		}
	}

	init() {
		// Set initial height
		this.updateLogoHeight();

		// Update on window resize
		window.addEventListener("resize", () => {
			this.updateLogoHeight();
		});

		// Update after fonts are loaded (if needed)
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => {
				this.updateLogoHeight();
			});
		}
	}

	updateLogoHeight() {
		// Only apply on desktop (lg breakpoint: 1024px+)
		if (window.innerWidth >= 1024) {
			const headlineHeight = this.headlineWrapper.offsetHeight;
			this.logoDesktop.style.height = `${headlineHeight}px`;
		} else {
			// Reset height on mobile
			this.logoDesktop.style.height = '';
		}
	}
}

// Initialize all showcase redesign components
const showcaseNodes = document.querySelectorAll(".section-showcase-redesign");
const showcases = [];
[...showcaseNodes].forEach(element => {
	showcases.push(new ShowcaseRedesign(element));
});

